module.exports = __webpack_public_path__ + "img/bg-5-2.d2bf4852.png";